module.exports = __webpack_public_path__ + "img/6.34c7f647.png";